import * as Yup from "yup"
import {ActionStatus, WorkflowStepType} from "../../../models";

export class ActionsAdvancedSearchForm
{
    pageSize: number = 10
    pageId: number = 0
    orderType: string | null = null
    orderBy: string | null = null
    executor: string | null = null
    statusList: string[] | null = null
    type: WorkflowStepType | null = null
    status: ActionStatus | null = null
    executionStartDate: Date | null = null
    executionEndDate: Date | null = null

    public toRequest() : ActionsAdvancedSearchForm {
        const request = new ActionsAdvancedSearchForm()

        request.executor = this.executor
        request.statusList = this.statusList
        request.type = this.type
        request.status = this.status
        request.executionStartDate = this.executionStartDate
        request.executionEndDate = this.executionEndDate

        return request

    }
}

const ActionsAdvancedSearchValidation = {
}

export default Yup.object()
    .shape(
        ActionsAdvancedSearchValidation,
    )
    .required()
